import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as debug from '../../../shared/services/debug.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { MenuService } from 'src/app/shared/services/menu.service';
import { PersistentDbService } from 'src/app/shared/services/persistent-db.service';
import { ErrorDbService } from 'src/app/shared/services/error-db.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { LogsCreateRequest } from 'src/app/shared/requests/logs-create-request';

@Component({
	selector: 'app-signout-redirect-callback',
	templateUrl: './signout-redirect-callback.component.html',
	styleUrls: ['./signout-redirect-callback.component.scss']
})
export class SignoutRedirectCallbackComponent implements OnInit {

	constructor(protected readonly menuService: MenuService
		, private router: Router
		, protected readonly securityService: SecurityService
		, protected readonly persistentDbService: PersistentDbService
		, private readonly errorDbService: ErrorDbService
		, private readonly notification: NotificationService
	) { }

	async ngOnInit() {
		setTimeout(() => {                          // fix ExpressionChangedAfterItHasBeenCheckedError
			this.menuService.setActiveModule('/', `SignoutRedirectCallbackComponent.ngOnInit`);  // simulate menu click
		}, 5);

		const postLogoutMsg = await this.errorDbService.getAll();
		const row = await this.persistentDbService.getRow();

		debug.log(`SignoutRedirectCallbackComponent`);
		this.securityService.completeLogout().then((user: any) => {
			if (!!row) {
				this.securityService.login();
			} else {
				if (postLogoutMsg.length > 0) {
					const item: LogsCreateRequest = JSON.parse(postLogoutMsg[0].error);
					this.notification.showWarning(item.message);
				}
				this.router.navigate(['/'], { replaceUrl: true });
				// setTimeout(() => {
				// 	if (postLogoutMsg.length > 0) {
				// 		const item: LogsCreateRequest = JSON.parse(postLogoutMsg[0].error);
				// 		this.notification.showWarning(item.message);
				// 	}
				// 	this.router.navigate(['/'], { replaceUrl: true });
				// }, 10);
			}
		});
	}
}
